import React, { useEffect } from "react";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { format } from "@origo_vl_banking/utils";

import { useDispatch, useSelector } from "react-redux";
import MonthCalculator from "./MonthCalculator";
import {
  Label,
  SpaceBetween,
} from "../../../components/grid/styled-components";
import { Small } from "../../../components/shared/styled-components";
import { ConsolidationPdfButton } from "../../../components/shared";
import { calcConsolidation } from "../actions";


function Cost() {
  const consolidation = useSelector((state) => state.consolidation);
  const dispatch = useDispatch();

  const handleGetPDF = () => {
    dispatch(calcConsolidation(true));
  };

  return (
    <>
      <MonthCalculator />

      <SpaceBetween>
        <Label>
          <FormattedMessage id="Application.PlannedFirstPayment" />
        </Label>
        <Label>
          {format.amount(Math.round(consolidation.plannedFirstPayment ?? 0))}{" "}
          kr.
        </Label>
      </SpaceBetween>
      <SpaceBetween>
        <Label>
          <FormattedMessage id="Application.FirstDueDate" />
        </Label>
        <Label>{moment(consolidation.firstDueDate).format("DD.MM.YYYY")}</Label>
      </SpaceBetween>
      <SpaceBetween>
        <Label>
          <FormattedMessage id="Application.CostPercent" />
        </Label>
        <Label>{format.decimal(consolidation.annualCostRatio ?? 0 * 100)}%</Label>
      </SpaceBetween>
      <SpaceBetween>
        <Label>
          <FormattedMessage id="Application.InterestPercent" />
        </Label>
        <Label>{format.decimal(consolidation.interestRate ?? 0 * 100)}%</Label>
      </SpaceBetween>

      <Small>
        Útreikningur miðast við ISK og að fyrsti vaxtadagur sé dagurinn í dag
      </Small>

      <ConsolidationPdfButton
        editable={consolidation.editable}
        hasPrice={consolidation.loanNetAmount > 0}
        calculate={handleGetPDF}
      />
    </>
  );
}

export default Cost;
